app.controller(
    'StockingVisuelController', ['$http', '$location', '$rootScope', '$scope', '$timeout', '$stateParams', 'StockingVisuelService', 'Upload', '$sce', '$state', 'TranslateService', StockingVisuelController]
);
function StockingVisuelController($http, $location, $rootScope, $scope, $timeout, $stateParams, StockingVisuelService, Upload, $sce, $state, TranslateService) {
    var vm = this;
    vm.modalObject = {};

    $scope.textEntered = null;
    $scope.notesEntered = null;
    $scope.selectedItem = null;
    $scope.explorerModel = null;
    $scope.explorerPath = null;
    $scope.currentViewEncryptedPath = null;
    $scope.count = 0;
    $scope.progress = "";
    $scope.list = [
    ];
    $scope.langs = [
    ];
    $scope.files = [];

    $scope.sortType = ''; // set the default sort type
    $scope.sortReverse = false;  // set the default sort order
    $scope.showFolders = false;
    $scope.showLang = false;

    $scope.modalNewFolder = false;
    $scope.modalUpload = false;
    $scope.modalRename = false;
    $scope.modalEditNotes = false;
    $scope.modalView = false;
    $scope.folderName = null;

    $scope.showOption = function (item, $event) {
        $event.stopPropagation();
        $scope.selectedItem = $scope.selectedItem === item ? null : item;
    };

    $scope.close = function () {

        if (!($scope.modalNewFolder || $scope.modalUpload || $scope.modalRename || $scope.modalEditNotes || $scope.modalView))
            $scope.selectedItem = null;
    };

    $scope.goPrev = function ($event) {
        $event.stopPropagation();
        let files = $scope.explorerModel.itemList.filter(item => item.IsFile === "1");
        let index = files.findIndex(file => file.EncryptedPath === $scope.currentViewEncryptedPath);
        if (index > 0) {
            $scope.currentViewEncryptedPath = files[index - 1].EncryptedPath;
            StockingVisuelService.ViewImageModal($scope.currentViewEncryptedPath, "image/jpg");
        }

    };

    $scope.goNext = function ($event) {
        $event.stopPropagation();
        let files = $scope.explorerModel.itemList.filter(item => item.IsFile === "1");
        let index = files.findIndex(file => file.EncryptedPath === $scope.currentViewEncryptedPath);
        if (index >= 0 && index < files.length) {
            $scope.currentViewEncryptedPath = files[index + 1].EncryptedPath;
            StockingVisuelService.ViewImageModal($scope.currentViewEncryptedPath, "image/jpg");
        }

    };

    $scope.showOptionLangs = function (item) {
        var current = item.option;
        angular.forEach($scope.langs, function (itm) {
            itm.option = false;
        });
        item.option = !current;
    };

    $scope.showOptionFiles = function (item) {
        var current = item.option;
        angular.forEach($scope.files, function (itm) {
            itm.option = false;
        });
        item.option = !current;
    };

    $scope.openFolder = function () {
        $scope.showFolders = true;
        $scope.showLang = false;
        console.log('@folder', $scope.showFolders);
        console.log('@lang', $scope.showLang);
    };

    $scope.openLang = function () {
        $scope.showLang = true;
        console.log('@folder', $scope.showFolders);
        console.log('@lang', $scope.showLang);
    };

    $scope.closeFolder = function () {
        $scope.showLang = false;
        $scope.showFolders = false;
        console.log('@folder', $scope.showFolders);
        console.log('@lang', $scope.showLang);
    };

    $scope.addFolderModal = function (name) {
        name = name.trim();
        var path = name;
        if ($stateParams.path !== undefined && name !== '')
            path = $stateParams.path + "/" + name;

        if (path !== '') {
            StockingVisuelService.Create(path)
                .then(function (message) {
                    $scope.addFolder(name);
                    $scope.modalNewFolder = false;
                    $scope.folderName = null;
                    //$location.url("/download?path=" + $stateParams.path);
                });
        }
    };

    $scope.openModal = function () {
        if ($scope.showFolders && $scope.showLang) {
            $scope.modalNewFolder = false;
        } else {
            $scope.modalNewFolder = true;
        }
    };

    $scope.addFolder = function (name) {
        $scope.explorerModel.itemList.unshift({ Name: name, Date: new Date(), Size: '0 B', IsFile: '0' });
    };

    $scope.closeView = function ($event) {
        $event.stopPropagation();
        $scope.modalView = false;
        let player = document.getElementById("blobviewer");
        player.src = "";
    };

    $scope.openModalName = function (name) {
        if (name === 'new') {
            $scope.modalNewFolder = true;
            setTimeout(function () {
                angular.element('#modalNewFolderInput').focus();
            });
        } else if (name === 'upload') {
            $scope.modalUpload = true;
            $scope.files = [];
            $scope.progress = "";
        }
        else if (name === 'rename') {
            $scope.modalRename = true;
            $scope.files = [];
            $scope.progress = "";
            setTimeout(function () {
                angular.element('#modalRenameInput').focus();
            });
        }
        else if (name === 'editNotes') {
            $scope.modalEditNotes = true;
            $scope.files = [];
            $scope.progress = "";
            setTimeout(function () {
                angular.element('#modalEditNotes').focus();
            });
        }
        else if (name === 'confirmDelete') {
            $scope.modalDelete = true;
            $scope.files = [];
            $scope.progress = "";
            setTimeout(function () {
                angular.element('#modalDelete').focus();
            });
        }
        else if (name === 'view') {
            $scope.modalView = true;
            $scope.progress = "";
            setTimeout(function () {
                angular.element('#modalView').focus();
            });
        }

    };

    // Call by confirm button of modalDelete
    $scope.deleteObject = function () {
        $scope.remove(vm.modalObject.l, vm.modalObject.event);
        $scope.modalDelete = false;
    };

    $scope.remove = function (path, $event) {
        $event.stopPropagation();

        StockingVisuelService.Remove(path)
            .then(function (model) {
                $scope.selectedItem = null;

                for (var i = $scope.explorerModel.itemList.length - 1; i >= 0; i--) {
                    if ($scope.explorerModel.itemList[i].Name === item.Name && $scope.explorerModel.itemList[i].IsFile === item.IsFile) {
                        $scope.explorerModel.itemList.splice(i, 1);
                    }
                }

                countresult();
            });
    };

    $scope.confirmDelete = function (item, $event) {
        $event.stopPropagation();
        vm.modalObject.l = item;
        vm.modalObject.event = $event;
        $scope.modalDelete = true;
        $scope.openModalName('confirmDelete');
    };

    $scope.rename = function (item, $event) {
        $event.stopPropagation();
        $scope.textEntered = item.Name;
        $scope.openModalName('rename');
    };

    $scope.editNotes = function (item, $event) {
        $event.stopPropagation();
        $scope.notesEntered = item.Notes;
        $scope.openModalName('editNotes');
    };

    $scope.download = function (path, $event) {
        $event.stopPropagation();

        StockingVisuelService.Download(path, "application/octet-stream")
            .then(function (response) {
                $scope.selectedItem = null;
            }, function (response) {
                if (response.status > 0) {
                    $scope.errorMsg = response.status + ': ' + response.data;
                }
            }, function (evt) {
                //console.log(evt);
                $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                //console.log($scope.progress);
            })
            ;
    };

    $scope.view = function (name, $event) {

        $event.stopPropagation();
        StockingVisuelService.ViewImageModal(name, "image/jpg");
        $scope.currentViewEncryptedPath = name;
        $scope.openModalName('view');
    };

    $scope.goto = function (folder, mode) {
        var path = folder;
        if ($stateParams.path !== undefined)
            path = $stateParams.path + "/" + folder;

        $location.url("/stockingvisuel?path=" + path + "&mode=" + mode);
    };

    $scope.saveEditedNotes = function (item, content) {
        var data = {
            EncryptedPath: item.EncryptedPath,
            Notes: content
        };

        StockingVisuelService.SaveNotes(data)
            .then(function (response) {
                if (response.data === "True") {
                    // Saved successfully. Close the modal, reload the screen
                    $scope.modalEditNotes = false;
                    initController();
                } else {
                    // Saving fail. Inform the user to try again
                    console.log("Notes saving error!");
                }
            })
            ;
    };

    $scope.renameFolder = function (item, newname) {
        var curName = item.Name;
        if ($stateParams.path !== undefined) {
            curName = $stateParams.path + "/" + item.Name;
            newname = $stateParams.path + "/" + newname;
        }

        if (curName && newname) {
            StockingVisuelService.Rename(curName, newname)
                .then(function (response) {
                    $timeout(function () {
                        $scope.result = response.data;
                        $scope.modalRename = false;
                        initController();
                    });
                }, function (response) {
                    if (response.status > 0) {
                        $scope.errorMsg = response.status + ': ' + response.data;
                    }
                }, function (evt) {
                    $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                    console.log($scope.progress);
                });
        }
    };

    $scope.deleteUploadFile = function (index) {
        $scope.files.splice(index, 1);
    };

    $scope.addUploadFilesByDragDrop = function (files) { $scope.addUploadFiles(files, true); };

    $scope.addUploadFiles = function (files, runApply) {
        if (files === undefined) { return; }

        let i;
        const compareFileName = function (x) {
            return x.name === files[i].name;
        };

        for (i = 0; i < files.length; i++) {
            // Check if user already select the file
            const filePosition = $scope.files.findIndex(compareFileName);

            if (filePosition === -1) {
                $scope.files.push(files[i]);
            } else {
                // Same file name, get the latter file
                $scope.files[filePosition] = files[i];
            }
        }

        if (runApply) { $scope.$apply(); }
    };

    $scope.isImageFile = function (fileType) {
        if (typeof fileType !== "string") { return false; }

        const supportType = "image/jpeg, image/png";
        return supportType.indexOf(fileType) >= 0;
    };

    $scope.uploadFiles = function () {
        var path = "";
        if ($stateParams.path !== undefined) { path = $stateParams.path + "/"; }

        // 85% <= uploadProgress <= 96%. The remain is for image processing in the server
        const uploadProgress = 85 + Math.floor(Math.random() * 10 + 1);

        if ($scope.files && $scope.files.length) {
            // Filter image files only
            let okFiles = [];
            $scope.files.forEach(file => {
                if ($scope.isImageFile(file.type)) { okFiles.push(file); }
            });
            if (okFiles.length === 0) { return; }

            StockingVisuelService.Upload(path, okFiles)
                .then(function (response) {
                    $timeout(function () {
                        $scope.result = response.data;
                        $scope.modalUpload = false;
                        $scope.files = [];
                        initController();
                    });
                }, function (response) {
                    if (response.status > 0) {
                        $scope.errorMsg = response.status + ': ' + response.data;
                    }
                }, function (evt) {
                    $scope.progress = Math.min(100, parseInt(uploadProgress * evt.loaded / evt.total)) + "%";
                });
        }
    };

    function countresult() {
        $scope.count = $scope.explorerModel.itemList.length;
    }

    function load(path, search, sort, reverse) {
        StockingVisuelService.GetIndexVisuel(path, search, sort, reverse)
            .then(function (model) {
                $scope.explorerModel = model.data;
                if (path !== "") {
                    var paths = path.split('/');
                    var js = [];
                    var curr = "";
                    for (var i = 0; i < paths.length; i++) {
                        if (curr !== "") {
                            curr += "/";
                        }
                        curr += paths[i];
                        let item = {};
                        item.path = curr;
                        item.name = paths[i];
                        js.push(item);
                    }
                    $scope.explorerPath = js;
                    $scope.files = js;
                }

                countresult();
            });
    }

    function getUrlVars() {
        let vars = {};
        decodeURIComponent(window.location.href).replace(/[?&]+([^=&]+)=([^&]*)/gi,
            function (m, key, value) {
                vars[key] = value;
            });
        return vars;
    }

    function readUrlParams() {
        // URL param = ?path=" + path + "&search=" + search + "&sort=" + sort + "&reverse=" + reverse

        const urlParams = getUrlVars();

        $rootScope.SideBarSearchVM.GlobalSearch.SearchValues = typeof urlParams.search === "undefined" ? {} : urlParams.search;

        $scope.sortType = typeof urlParams.sort === "undefined" ? "" : urlParams.sort;
        $scope.sortReverse = typeof urlParams.sort === "undefined" ? false : urlParams.reverse;
    }

    function initController() {
        TranslateService.use($rootScope.LangForInterface);

        readUrlParams();

        if ($stateParams.path !== undefined)
            load($stateParams.path, "", $scope.sortType, $scope.sortReverse);
        else
            load("", "", $scope.sortType, $scope.sortReverse);
    }

    initController();

    const searchCategory = ["All", "Filename", "Notes", "Description", "Credit", "Category"];
    const searchCategoryTranslation = ["all.StockingVisuel", "filename.StockingVisuel", "notes.StockingVisuel", "description.StockingVisuel", "credit.StockingVisuel", "category.StockingVisuel"];

    // note the name 'SearchColummnList' with double mm
    $rootScope.SideBarSearchVM.GlobalSearch.SearchColummnList = searchCategoryTranslation;
    $rootScope.SideBarSearchVM.GlobalSearch.Paths = ["vouseffectuezunerecherchedans", "stockingVisuel", " > " + ($stateParams.path ? $stateParams.path.split('/').join(" > ") : "")];

    $rootScope.removeTags = function (key) {
        delete $rootScope.SideBarSearchVM.GlobalSearch.SearchValues[key];
        $rootScope.AdvancedSearch();
    };

    $rootScope.AdvancedSearch = function AdvancedSearch() {
        let search = [];
        Object.keys($rootScope.SideBarSearchVM.GlobalSearch.SearchValues).forEach(function (key) {
            search.push(searchCategory[searchCategoryTranslation.indexOf(key)] + "=" + $rootScope.SideBarSearchVM.GlobalSearch.SearchValues[key]);
        });

        if ($stateParams.path !== undefined)
            load($stateParams.path, search.join("|"), "", false);
        else
            load("", search.join("|"), "", false);
    };

    $rootScope.GlobalAdvancedSearch = function GlobalAdvancedSearch(key, value) {
        if (value !== null) {
            $rootScope.SideBarSearchVM.GlobalSearch.SearchValues[key] = value;
            $rootScope.SideBarSearchVM.GlobalSearch.Keyword = "";
            $rootScope.AdvancedSearch();
        }
    };

    $scope.navigation = function (keyVal) {
        if ($scope.modalView) {
            if (keyVal === 37) {
                goPrev();
            }
            else if (keyVal === 39) {
                goNext();
            }
        }
    };

}